<template>
    <div >

        <h1 align="center">
            <strong><u>COOKIE POLICY</u></strong>
        </h1>
        <p>
            Last updated on 29.12.2021
        </p>
        <p>
            This policy describes how <strong>TravelQuest</strong>, having its
            registered office in <strong>Sderot Tsahal 4, Lod, Israel</strong>
            (hereinafter referred to as the <strong>“TravelQuest”</strong> or    <strong>“we”</strong> or <strong>“our”</strong> or <strong>“us”</strong>)
            uses cookies on <a href="https://travelquest.xyz/">TravelQuest.xyz</a> and (the<strong>“Site”</strong>). We recommend that you also consult our    <strong>Privacy Policy</strong> for additional information on how we
            collect and use information collected from visitors to the Site. This
            policy is effective from the <em>‘Last Updated’</em> date mentioned above.
            Your continued use of the Site after that will signify your acceptance of
            this policy. We may modify this Agreement without notifying you, so please
            check back often for updates.
        </p>
        <p>
            By using the Site, you agree that we can use the cookies described in this
            Cookie Policy. You can stop cookies by changing the settings in your
            browser (more information on how to do this is provided below).
        </p>
        <p>
            <strong>WHAT ARE COOKIES?</strong>
        </p>
        <p>
            Cookies are text files, containing small amounts of information, which are
            downloaded to your browsing device (such as a computer or smartphone) when
            you visit a website. Cookies can be recognized by the website that
            downloaded them — or other websites that use the same cookies. This helps
            websites know if the browsing device has visited them before.
        </p>
        <p>
            <strong>WHAT ARE COOKIES USED FOR?</strong>
        </p>
        <p>
            Cookies do lots of different jobs, like helping us understand how the Site
            is being used, letting you navigate between pages efficiently, remembering
            your preferences, and generally improving your browsing experience. Cookies
            can also help ensure marketing you see virtual is more relevant to you and
            your interests.
        </p>
        <p>
            We use cookies to recognize your browser or device, learn more about your
            interests, and provide you with essential features and services and for
            additional purposes, including:
        </p>
        <ul type="disc">
            <li>
                Recognizing you when you sign-in to use our services, which allows us
                to provide you with product recommendations, display personalized
                content, and provide other customized features and services.
            </li>
            <li>
                Keeping track of your specified preferences.
            </li>
            <li>
                Keeping track of items stored in your shopping cart.
            </li>
            <li>
                Conducting research and diagnostics to improve our content, products,
                and services.
            </li>
            <li>
                Preventing fraudulent activity.
            </li>
            <li>
                Improving security.
            </li>
            <li>
                Delivering content, including ads relevant to your interests.
            </li>
            <li>
                For measuring and analyzing the performance of our services.
            </li>
        </ul>
        <p>
            Our cookies allow you to take advantage of some of our essential features.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>WHAT TYPES OF COOKIES DO WE USE?</strong>
        </p>
        <p>
            The type of cookies used on most websites can generally be put into one of
            six categories:
            <em>
                Strictly Necessary, Performance, Functionality, Flash, Tailored Content
                and Targeting
            </em>
            . In order to provide you with the best browsing experience, TravelQuest
            uses all of these categories on the Site. You can find out more about each
            cookie category in the sections below.
        </p>
        <p>
            <strong>Strictly Necessary Cookies:-</strong>
        </p>
        <p>
            These cookies are essential, as they enable you to move around the Site and
            use its features, such as accessing secure areas. Without these cookies,
            some services you have asked for such as payment submission can’t be
            provided.
        </p>
        <p>
            <strong>Performance Cookies:-</strong>
        </p>
        <p>
            These cookies collect information about how you use the Site, for example
            which pages you go to most often and if you get error messages from certain
            pages. These cookies don’t gather information that identifies you. All
            information these cookies collect is anonymous and is only used to improve
            how the Site works.
        </p>
        <p>
            <strong>Functionality Cookies:-</strong>
        </p>
        <p>
            These cookies allow the Site to remember choices you make (such as your
            user name, language or the region you’re in). For instance, the Site uses
            functionality cookies to remember your region preference. These cookies can
            also be used to remember changes you’ve made to text size, font and other
            parts of pages that you can customize. The information these cookies
            collect may be anonymous and they cannot track your browsing activity on
            other websites.
        </p>
        <p>
            <strong>Flash Cookies:-</strong>
        </p>
        <p>
            We may, in certain circumstances, use Adobe Flash Player to deliver special
            content, such as video clips or animation. To improve your user experience,
            Local Shared Objects (commonly known as <strong>“Flash cookies”</strong>)
            are employed to provide functions such as remembering your settings and
            preferences. Flash cookies are stored on your device, but they are managed
            through an interface different from the one provided by your web browser.
            This means it is not possible to manage Flash cookies through your browser
            in the same way you would normally manage cookies. Instead, you can access
            your Flash management tools from Adobe’s website at
            <a
                href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html"
            >
                http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html
            </a>
            .
        </p>
        <p>
            <strong>Tailored Content Cookies:</strong>
        </p>
        <p>
            Tailored content cookies help the Site provide enhanced features and
            display content in a way that is relevant to you. These cookies help the
            Site determine what information to show you based on how you have used the
            Site previously. These cookies do not track your browsing activity on other
            websites.
        </p>
        <p>
            <strong>Targeting Cookies:</strong>
        </p>
        <p>
            These cookies are used to deliver advertisements that are more relevant to
            you and your interests. They are also used to limit the number of times you
            see an advertisement as well as help measure the effectiveness of an
            advertising campaign. They remember that you have visited a website and
            this information may be shared with other organizations such as
            advertisers. This means after you have been to the Site you may see some
            advertisements about our services elsewhere on the Internet.
        </p>
        <p>
            <strong>HOW LONG WILL COOKIES STAY ON MY BROWSING DEVICE?</strong>
        </p>
        <p>
            The length of time a cookie will stay on your browsing device depends on
            whether it is a “persistent” or “session” cookie. Session cookies will only
            stay on your device until you stop browsing. Persistent cookies stay on
            your browsing device until they expire or are deleted.
        </p>
        <p>
            <strong>FIRST AND THIRD-PARTY COOKIES</strong>
        </p>
        <p>
            First party cookies are cookies that belong to us, while third party
            cookies are cookies that another party places on your browsing device
            through our Site. For example, third party website will place a cookie on
            your browsing device if you click on such third-party website link when
            browsing the Site.
        </p>
        <p>
            <strong>HOW TO CONTROL AND DELETE COOKIES THROUGH YOUR BROWSER</strong>
        </p>
        <p>
            The browser you are using to view the Site can enable, disable or delete
            cookies. To do this, follow the instructions provided by your browser (    <em>usually located within the “Help,” “Tools” or “Edit” facility</em>).
            Please note that if you set your browser to disable cookies, you may not be
            able to access certain parts of the Site. Other parts of the Site may also
            not work properly. You can find out more information about how to change
            your browser cookie settings at    <a href="http://www.allaboutcookies.org/">www.allaboutcookies.org</a>.
        </p>
        <p>
            <strong>Contacting Us</strong>
        </p>
        <p>
            If you have any questions about this Cookie Policy, please contact us at
            dan@TravelAndQuest.com
        </p>
        <br/>
    </div>
</template>

<script>
export default {
    name: "v_Terms_CookiePolicy"
}
</script>

<style scoped lang="scss">

    p{
        margin: 16px;
    }
</style>